import { render } from "./setting.vue?vue&type=template&id=57cf06f0&scoped=true&ts=true"
import script from "./setting.vue?vue&type=script&lang=ts"
export * from "./setting.vue?vue&type=script&lang=ts"

import "./setting.vue?vue&type=style&index=0&id=57cf06f0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cf06f0"]])

export default __exports__